import * as i0 from '@angular/core';
import { model, input, computed, Component, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
import { NgxIcon } from '@digipay/ngx-icon';
const _c0 = ["*"];
const _c1 = a0 => ({
  "cursor-pointer no-select": a0
});
function NgxCheckboxComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("classes", "text-oninvert-high")("iconSize", ctx_r0.size().toString() + "px")("name", "Check")("type", "linear");
  }
}
let NgxCheckboxComponent = /*#__PURE__*/(() => {
  class NgxCheckboxComponent {
    constructor() {
      this.checked = model(false);
      this.size = input(24);
      this.disabled = input(false);
      this.disableTextClick = input(false);
      this.wrapperCLasses = computed(() => this.generateWrapperClasses());
      this.styleConfig = computed(() => ({
        width: `${this.size()}px`,
        height: `${this.size()}px`,
        flex: `0 0 ${this.size()}px`
      }));
    }
    generateWrapperClasses() {
      const sizeClassMap = {
        16: ['radius-tiny', 'border-200'],
        20: ['radius-mini', 'border-300'],
        24: ['radius-small', 'border-400']
      };
      let colorClass;
      if (this.disabled()) {
        // TODO: these background colors need to be changed
        colorClass = this.checked() ? 'border-color-air surface-dim-level-0' : 'border-color-air surface-elevated';
      } else {
        colorClass = this.checked() ? 'border-color-brand surface-brand' : 'border-color-tint surface-elevated';
      }
      return `${colorClass} ${sizeClassMap[this.size()].join(' ')}`;
    }
    itemClick() {
      if (!this.disabled()) {
        this.checked.update(ex => !ex);
      }
    }
    handleTextLink() {
      if (!this.disableTextClick()) {
        this.itemClick();
      }
    }
    static {
      this.ɵfac = function NgxCheckboxComponent_Factory(t) {
        return new (t || NgxCheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxCheckboxComponent,
        selectors: [["ngx-checkbox"]],
        inputs: {
          checked: [i0.ɵɵInputFlags.SignalBased, "checked"],
          size: [i0.ɵɵInputFlags.SignalBased, "size"],
          disabled: [i0.ɵɵInputFlags.SignalBased, "disabled"],
          disableTextClick: [i0.ɵɵInputFlags.SignalBased, "disableTextClick"]
        },
        outputs: {
          checked: "checkedChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 7,
        consts: [[1, "d-flex", "align-items-start", "justify-content-center", "gap-tiny"], [3, "click", "ngStyle"], [3, "classes", "iconSize", "name", "type"], [1, "checkbox-label", 3, "click", "ngClass"]],
        template: function NgxCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵlistener("click", function NgxCheckboxComponent_Template_div_click_1_listener() {
              return ctx.itemClick();
            });
            i0.ɵɵtemplate(2, NgxCheckboxComponent_Conditional_2_Template, 1, 4, "ngx-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵlistener("click", function NgxCheckboxComponent_Template_div_click_3_listener() {
              return ctx.handleTextLink();
            });
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassMap("check-box-wrapper d-flex align-items-center justify-content-center" + ctx.wrapperCLasses());
            i0.ɵɵproperty("ngStyle", ctx.styleConfig());
            i0.ɵɵadvance();
            i0.ɵɵconditional(2, ctx.checked() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1, !ctx.disableTextClick()));
          }
        },
        dependencies: [NgStyle, NgxIcon, NgClass],
        styles: [".no-select[_ngcontent-%COMP%]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}"],
        changeDetection: 0
      });
    }
  }
  return NgxCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-checkbox
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxCheckboxComponent };
